import { render } from "./ARadioGroup.vue?vue&type=template&id=325357d9"
import script from "./ARadioGroup.vue?vue&type=script&lang=js"
export * from "./ARadioGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__